import React,{useState, useEffect} from "react";

// import { Divider, Drawer, Space, Button } from "antd";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import {getAllOrdersAction} from "../../store/order/actions"
import { useSelector,useDispatch } from "react-redux";
import Skeleton from 'react-loading-skeleton'

const OrdersSkeleton = ({cards}:any) => {
   
  return (
        <>
        {Array(cards).fill(0).map((el: any, index: any) => (
            <tr key={index}>
                <td className="cart_product_img">
                    <Skeleton width={240.3} height={240.3}/>
                </td>
                <td className="cart_product_desc">
                    <h5><Skeleton /></h5>
                    <p><Skeleton /></p>
                </td>
                <td className="price">
                    <span><Skeleton /></span>
                </td>
                <td className="qty">
                        <span><Skeleton /></span>
                    
                </td>
                <td className="qty">
                        <span><Skeleton /></span>
                    
                </td>
                
            </tr>
            ))}
        </>
                      
  );
};

export default OrdersSkeleton;
